import React from 'react';
import { GenericFilterDrawer } from './GenericFilterDrawer';

export const FILTER_ALL = 'ALL';
export const FILTER_MARBLES = 'MARBLES';
export const FILTER_BINGO = 'BINGO';
export const FILTER_RDR = 'RACE DAY';
export const FILTER_LEVIATHAN = 'LEVIATHAN';
export const FILTER_MOST_RECENT = 'MOST RECENT';
export const FILTER_OLDEST = 'OLDEST';
export const FILTER_10_PLAYER = 'AUDIENCE <= 10';
export const FILTER_10_100_PLAYER = 'AUDIENCE <= 100';
export const FILTER_100_1000_PLAYER = 'AUDIENCE <= 1000';
export const FILTER_1000_PLAYER = 'AUDIENCE 1000 +';

interface DefaultDrawerProps {
    onClose: () => void;
    resetFilters: () => void;
    applyFilters: () => void;
    isOpen: boolean;
    updateGameTitleFilter: (val: string) => void;
    gameTitleFilter: string;
    updateGameDurationFilter: (val: string) => void;
    gameDurationFilter: string;
    updateGameAudienceSizeFilter: (val: string) => void;
    gameAudienceSizeFilter: string;
}

export const DashboardSessionsFilterDrawer: React.FC<DefaultDrawerProps> = ({
    isOpen,
    applyFilters,
    resetFilters,
    onClose,
    updateGameTitleFilter,
    gameTitleFilter,
    updateGameDurationFilter,
    gameDurationFilter,
    updateGameAudienceSizeFilter,
    gameAudienceSizeFilter,
}) => (
    <GenericFilterDrawer
        filterAll={FILTER_ALL}
        onClose={onClose}
        isOpen={isOpen}
        resetFilters={resetFilters}
        applyFilters={applyFilters}
        sections={[
            {
                otherOptions: [FILTER_MARBLES, FILTER_BINGO, FILTER_LEVIATHAN, FILTER_RDR],
                updateFunc: updateGameTitleFilter,
                currentValueStateValue: gameTitleFilter,
                name: 'Sixes',
                groupName: 'gameFilterGroup',
                groupCssClass: 'game-filters',
            },
            {
                otherOptions: [FILTER_MOST_RECENT, FILTER_OLDEST],
                updateFunc: updateGameDurationFilter,
                currentValueStateValue: gameDurationFilter,
                name: 'Time',
                groupCssClass: 'time-filters',
                groupName: 'onlineFilterGroup',
            },
            {
                otherOptions: [
                    FILTER_10_PLAYER,
                    FILTER_10_100_PLAYER,
                    FILTER_100_1000_PLAYER,
                    FILTER_1000_PLAYER,
                ],
                updateFunc: updateGameAudienceSizeFilter,
                currentValueStateValue: gameAudienceSizeFilter,
                name: 'Audience Size',
                groupCssClass: 'audience-filters',
                groupName: 'onlineFilterGroup',
            },
        ]}
    />
);
